import React, { useState, useEffect } from 'react';
import { useNavigate, Link, useParams } from 'react-router-dom';
import logo from '../assets/images/logo.svg';
import '../assets/css/bootstrap.min.css';
import '../assets/css/remixicon.css';
import '../assets/css/flaticon.css';
import '../assets/css/style.css';
import '../assets/css/responsive.css';

const Header = () => {
  const { userId } = useParams();
  const navigate = useNavigate();
  const [menuItems, setMenuItems] = useState([]);
  const [user, setUser] = useState(null);
  const [mobileMenuVisible, setMobileMenuVisible] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [userData, setUserData] = useState(null);


  const toggleMobileMenu = () => {
    setMobileMenuVisible((prevState) => !prevState);
  };

  useEffect(() => {
    fetch('https://dayoffice24.it/api/menu')
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then((data) => {
        if (data.success) {
          setMenuItems(data.data);
        } else {
          throw new Error('API returned an error: ' + data.message);
        }
      })
      .catch((error) => {
        console.error('Error fetching menu data:', error);
      });

    const usertoken = localStorage.getItem('token');
    if (usertoken) {
      setUser(true);

      // Fetch the user's profile data using the profile API
      fetch('https://dayoffice24.it/api/profile', {
        redirect: 'manual',
        headers: {
          Authorization: `Bearer ${usertoken}`,
        },
      })
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else if (response.status === 302) {
            // Handle the redirection
            const newUrl = response.headers.get('Location');
            if (newUrl) {
              return fetch(newUrl); // Follow the redirection manually
            } else {
              throw new Error('Redirection URL not provided.');
            }
          } else {
            throw new Error('Network response was not ok');
          }
        })
        .then((data) => {
          if (data.success) {
            setUserData(data.data); // Set the user's profile data received from the API to the state
          } else {
            throw new Error('API returned an error: ' + data.message);
          }
        })
        .catch((error) => {
          console.error('Error fetching profile data:', error);
        });
    } else {
      setUser(false);
    }
  }, []);


  const toggleDropdown = () => {
    setShowDropdown((prevState) => !prevState);
  };

   const closeMobileMenu = () => {
    setMobileMenuVisible(false);
  }; 

  // Logout function to handle the logout API call
  const handleLogout = () => {
    fetch('https://dayoffice24.it/api/logout', {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          // Clear the user data from local storage
          localStorage.removeItem('token');
          // Navigate the user to the homepage
          navigate('/');
        } else {
          console.error('Logout failed:', data.message);
        }
      })
      .catch((error) => {
        console.error('Error logging out:', error);
      });
  };


  return (
    <header className="header-wrap style1">
      <div className="container">
        <nav className="navbar navbar-expand-md navbar-light">
          <a className="navbar-brand">
            <Link to="/"><img className="logo-light" src={logo} alt="logo" /></Link>
          </a>
          <div className={`navbar-collapse main-menu-wrap ${mobileMenuVisible ? 'open' : ''}`} id="navbarSupportedContent">
            <div class="menu-close d-lg-none">
                <a href="javascript:void(0)" onClick={toggleMobileMenu}> <i class="ri-close-line"></i> </a>
             </div>
            <ul className="navbar-nav ms-auto">
              <li className="nav-item">
                <Link to="/" className="nav-link">
                  Home
                </Link>
              </li>
              {!user && (
                <li className="nav-item">
                  <Link to="/BecomeHost" className="nav-link">
                    Become an Host
                  </Link>
                </li>
              )}
              {menuItems.length > 0 ? (
                menuItems.map((menuItem) => (
                  <li key={menuItem._id} className="nav-item">
                    <Link to={`/category/${menuItem._id}`} className="nav-link">
                      {menuItem.category_name}
                    </Link>
                  </li>
                ))
              ) : (
                <li className="nav-item">
                  <span className="nav-link">Loading...</span>
                </li>
              )}
            </ul>
            <div className="others-options">
              {user ? (
                <div className="block_after_login">
                  <div className="dropdown" onClick={toggleDropdown}>
                    <div className="profile_name">
                      {userData && (
                      <div className="profile_name">
                        <img src={userData.avatar} alt="Profile" />
                        {userData.name} <i className="ri-arrow-drop-down-line"></i>
                      </div>
                    )}
                    </div>
                    <div className={`dropdown-content ${showDropdown ? 'show' : ''}`}>
                      <Link className="dropdown-item" to="/Profile">Profile</Link>
                      <div className="dropdown-divider"></div>
                      <Link className="dropdown-item" to="/EditProfile">Edit Profile</Link>
                      <div className="dropdown-divider"></div>
                      <Link className="dropdown-item"  to="/ChangePassword">Change Password</Link>
                      <div className="dropdown-divider"></div>
                      <Link className="dropdown-item"  to="/OrderHistory">Order History</Link>
                      <div className="dropdown-divider"></div>
                      <Link onClick={handleLogout} className="dropdown-item">Logout</Link>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="header-btn">  
                  <Link className="btn style3" to="/Login">Sign In</Link>
                  <Link className="btn style1" to="https://dayoffice24.it/login">Host Login</Link>
                </div>
              )}
            </div>
          </div>
        </nav>
        <div className="mobile-bar-wrap">
          <div className="mobile-menu d-lg-none">
            <a onClick={toggleMobileMenu}>
              <i className="ri-menu-line"></i>
            </a>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
